import React from "react"

class HeaderComponent extends React.Component {

	render() {
		return (
			<div className="custom-header-cell">
				{this.props.row.title}
				{
					!this.props.row.readOnly ?
					<div className="actions">
						<button onClick={this._handleClick.bind(this)} title="Modifier la dépense"><i className="fa fa-edit" /></button>
						<button onClick={this._handleDeleteClick.bind(this)} title="Supprimer la dépense"><i className="fa fa-trash" /></button>
					</div>
					: null
				}				
			</div>
		)
	}

	_handleClick() {
		this.props.onCustomAction("alter_expense", this.props.ppi.expenses[this.props.row.index])
	}

	_handleDeleteClick() {
		this.props.onCustomAction("destroy_expense", this.props.ppi.expenses[this.props.row.index])
	}

}

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/expenses/header-component.js